import React from 'react';
import { Modal } from 'carbon-components-react';

export const ResponsesExpiredModal: React.FC<Props | any> = (props: Props) => {
  const { showResponsesExpiredModal, onClickClose } = props;

  return (
    <div className="responses-expired-modal-wrapper">
      <Modal
        open={showResponsesExpiredModal}
        modalHeading={`This enquiry's responses are no longer available`}
        size="xs"
        className="responses-expired-modal"
        secondaryButtonText={'Close'}
        primaryButtonText={''}
        onSecondarySubmit={() => onClickClose()}
      >
        Responses are automatically deleted 90 days after the date they were
        received. You can still see the enquiry details and duplicate the
        enquiry.
      </Modal>
    </div>
  );
};

type ownProps = {
  showResponsesExpiredModal: boolean;
  onClickClose: Function;
  isModal: boolean;
};

type Props = ownProps;

ResponsesExpiredModal.displayName = 'ResponsesExpiredModal';

export default React.memo(ResponsesExpiredModal);
